<template>
  <v-app :dark="themeSwitch ? true : false">

    <v-navigation-drawer :dark="themeSwitch ? true : false" persistent :mini-variant="miniVariant" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed app>
      <v-list>
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push('/home')"><v-icon>home</v-icon></v-list-tile-action>
          <v-list-tile-content @click="$router.push('/home')"><v-list-tile-title>Home</v-list-tile-title></v-list-tile-content>          
        </v-list-tile>
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push('/projects')"><v-icon>public</v-icon></v-list-tile-action>
          <v-list-tile-content @click="$router.push('/projects')"><v-list-tile-title>Projects</v-list-tile-title></v-list-tile-content>          
        </v-list-tile>
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push('/users')"><v-icon>people</v-icon></v-list-tile-action>
          <v-list-tile-content @click="$router.push('/users')"><v-list-tile-title>Users</v-list-tile-title></v-list-tile-content>          
        </v-list-tile>
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push('/roles')"><v-icon>device_hub</v-icon></v-list-tile-action>
          <v-list-tile-content @click="$router.push('/roles')"><v-list-tile-title>Roles</v-list-tile-title></v-list-tile-content>          
        </v-list-tile>
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push('/gnipRules')"><v-icon>playlist_add</v-icon></v-list-tile-action>
          <v-list-tile-content @click="$router.push('/gnipRules')"><v-list-tile-title>GNIP Rules</v-list-tile-title></v-list-tile-content>          
        </v-list-tile>
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push('/custom-reports')"><v-icon>folder_open</v-icon></v-list-tile-action>
          <v-list-tile-content @click="$router.push('/custom-reports')"><v-list-tile-title>Custom Reports</v-list-tile-title></v-list-tile-content>          
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app :dark="themeSwitch ? true : false" :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <!-- <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn> -->

      <img src="@/assets/YakshofLogo.png" alt="Yakshof">
      <v-toolbar-title v-text="title" class="ml-2"></v-toolbar-title>
      <v-spacer></v-spacer>
      
      <!-- <div class="text-xs-left" v-if="isLoggedIn"><v-chip color="primary"><v-icon>account_box</v-icon>{{currentUser.firstName}} {{currentUser.lastName}}</v-chip></div> -->
      <div class="text-xs-center" v-if="!isLoggedIn"><v-chip color="primary">You need to login first</v-chip></div>
      
      <v-menu bottom left v-if="isLoggedIn" offset-y>
        <div id="userChip" slot="activator" class="text-xs-left pointerClass" v-if="isLoggedIn"><v-chip class="pointerClass hover" color="primary"><v-icon>account_box</v-icon><span>{{currentUser.firstName}} {{currentUser.lastName}}</span></v-chip></div>
        <!-- <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn> -->
        <v-list>
          <v-list-tile @click="$router.push('/login'); $store.dispatch('auth/logout')">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>Dark Theme</v-list-tile-title>
            <v-switch color='primary' class='justify-center align-items-center themeSwitch' v-model="themeSwitch"></v-switch>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content style="height: 100%">
      <router-view/>
    </v-content>
    
    <notifier></notifier>
    <loading></loading>
    
    <!-- <v-footer :dark="themeSwitch ? true : false" :fixed="fixed" app>
      <span>&copy; 2018</span>
    </v-footer> -->
  </v-app>
</template>

<style type="text/css">
.application .theme--dark.navigation-drawer, .theme--dark .navigation-drawer {
  background-color: #212121 !important
}
.application .theme--dark.chip, .theme--dark .chip{
  background: #f8a135 !important
}
::selection {
  background-color: #f8a135 !important
}
.themeSwitch .input-group__details{
  display: none !important
}
.pointerClass{
  cursor: pointer;
}
#userChip .v-chip:hover{
  border-color: rgba(0,0,0,.13);
  -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
</style>

<script>
import Notifier from './components/Notifier'
import Loading from './components/Loading'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: true,
      title: 'Yakshof Admin'
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({getTheme: 'getTheme'}),
    themeSwitch: {
      get: function () {
        return this.getTheme
      },
      set: function () {
        this.updateTheme()
      }
    }
  },
  methods: {
    ...mapMutations(['updateTheme'])
  },
  name: 'App',
  components: {Notifier, Loading}
}
</script>



// WEBPACK FOOTER //
// src/App.vue